'use client';

import { getKeyValue } from '@/services/content/data';
import { useSearchContext } from '@/services/search/SearchProvider';
import { SearchPageConfigProperties } from '@/types/contentStack';
import type { ContentStackEntryDataProps } from '@nxt-costco-com/forge-digital-components';

import { NO_MATCH_TEXT_KEY, TRY_ANOTHER_TEXT_KEY } from './constants';

import {
    StyledHeadingTwoPartH1,
    StyledHeadingTwoPartH2,
    StyledHeadingTwoPartParent,
} from './styles';

export const SemanticResultsHeader = ({
    pageConfig,
}: {
    pageConfig: ContentStackEntryDataProps<SearchPageConfigProperties>;
}) => {
    const { searchResult } = useSearchContext();
    if (!searchResult) {
        return null;
    }
    const { metrics } = searchResult;
    // If no semantic, return null
    if (!metrics?.semantic || !pageConfig) {
        return null;
    }

    return (
        <StyledHeadingTwoPartParent>
            {/* "We were not able to find a match..." */}
            <StyledHeadingTwoPartH1>
                {getKeyValue(NO_MATCH_TEXT_KEY, pageConfig)}
            </StyledHeadingTwoPartH1>
            {/* "Try another..." */}
            <StyledHeadingTwoPartH2>
                {getKeyValue(TRY_ANOTHER_TEXT_KEY, pageConfig)}
            </StyledHeadingTwoPartH2>
        </StyledHeadingTwoPartParent>
    );
};
